module.exports = __webpack_public_path__ + "static/screen-2@3x-0e2c0a03d86678277c99bda3e505d336.png";